module.exports = __webpack_public_path__ + "images/emoji/circus_tent.53b845cd00096be8c997.png";